export enum CalendarMessage {
  BUTTON_RESET = 'Reset',
  BUTTON_DONE = 'Done',
}
